import { brand } from "../../../context";

export function CancelButton({ onCancel }: { onCancel: () => void }) {
  return (
    <button
      className="Button"
      type="button"
      data-brand={brand}
      onClick={(e) => {
        e.preventDefault();
        onCancel();
      }}
    >
      Cancel
    </button>
  );
}


export function CloseButton({ onClose }: { onClose: () => void }) {
  return (
    <button
      className="Button"
      type="button"
      data-brand={brand}
      onClick={(e) => {
        e.preventDefault();
        onClose();
      }}
    >
      Close
    </button>
  );
}


export function BackButton({ onBack }: { onBack: () => void }) {
  return (
    <button
      className="Button"
      type="button"
      data-brand={brand}
      onClick={(e) => {
        e.preventDefault();
        onBack();
      }}
    >
      Back
    </button>
  );
}
